import React from 'react';

import {
  Pagination,
  PaginationContent,
  PaginationItem,
} from '@/components/ui/pagination';
import { Skeleton as ShadcnSkeleton } from '@/components/ui/skeleton';

const EllipsisSkeleton = () => (
  <PaginationItem>
    <ShadcnSkeleton className="h-4 w-4" />
  </PaginationItem>
);

const NextPrevSkeleton = () => (
  <PaginationItem>
    <ShadcnSkeleton className="h-9 w-24" />
  </PaginationItem>
);

const PageNumberSkeleton = () => (
  <PaginationItem>
    <ShadcnSkeleton className="h-9 w-9" />
  </PaginationItem>
);

const Skeleton = () => (
  <Pagination>
    <PaginationContent>
      <NextPrevSkeleton />
      <PageNumberSkeleton />
      <EllipsisSkeleton />

      {Array.from({ length: 3 }, (_, i) => (
        <PageNumberSkeleton key={i} />
      ))}

      <EllipsisSkeleton />
      <PageNumberSkeleton />
      <NextPrevSkeleton />
    </PaginationContent>
  </Pagination>
);

export default Skeleton;
